import { AppTemplate } from '@revenuewell/logic-app-template';
import ReactDOM from 'react-dom/client';
import App from './components/layout/app/app';
import AppProviders from './components/layout/app/app-provider-list';
import CONFIG from './config/config.json';
import './global.scss';
import { AppRoutes } from './routing/app-routes';

function Index() {
  return (
    <AppTemplate
      // todo: define dynamically when Wrapper production configuration will be ready
      isProduction={true}
      devConfig={CONFIG}
      routes={AppRoutes}
      preload={{ products: true }}
    >
      <AppProviders>
        <App />
      </AppProviders>
    </AppTemplate>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// todo: enable strict mode for development when Wrapper production configuration will be ready
root.render(
  // <StrictMode>
  <Index />
  // </StrictMode>
);
